module.exports = {"identity":{"baseUrl":"https://collectionsapi.stg-prsn.com/api/identity/v1"},"contentService":{"baseUrl":"https://collectionsapi.stg-prsn.com/api/content/v1"},"collectionService":{"baseUrl":"https://collectionsapi.stg-prsn.com/api/collection/v1"}}


//////////////////
// WEBPACK FOOTER
// ./src/config/stg.config.json
// module id = 276
// module chunks = 0